import React, { useState } from 'react';
import { 
  Box, 
  Select, 
  MenuItem, 
  FormControl, 
  Typography
} from '@mui/material';

const CustomPagination = ({ 
  itemsPerPage = 5,  
  onItemsPerPageChange 
}) => {
  const [rowsPerPage, setRowsPerPage] = useState(itemsPerPage);

  const handleItemsPerPageChange = (event) => {
    const newRowsPerPage = event.target.value;
    setRowsPerPage(newRowsPerPage);
    onItemsPerPageChange && onItemsPerPageChange(newRowsPerPage, 1);
  };

  return (
    <Box 
      display="flex" 
      justifyContent="end" 
      alignItems="center" 
      p={2}
      className="bg-white dark:bg-[#1A1F2C]"
      flexWrap="wrap"
      gap={2}
    >
      <Box className="d-flex flex-center flex-justify-end"  gap={1}>
        <Typography variant="body2" className="text-[#020817] dark:text-[#94A3B8]">
          Records Per Page:
        </Typography>
        <FormControl size="small" variant="outlined">
          <Select
            value={rowsPerPage}
            onChange={handleItemsPerPageChange}
            className="min-w-[70px] dark:text-white"
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'transparent',
                '& fieldset': {
                  borderColor: '#E2E8F0',
                },
                '&:hover fieldset': {
                  borderColor: '#CBD5E1',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#3B82F6',
                },
              },
              '& .MuiSelect-select': {
                color: 'inherit',
                padding: '8px 12px',
              }
            }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={15}>15</MenuItem>
            <MenuItem value={20}>20</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="body2" className="text-[#020817] dark:text-[#94A3B8]">
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomPagination;